<template>
  <div class="output-setting">
    <!-- Confirmation modal -->
    <b-modal
      id="removeOutput_ConfirmModal"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      :scrollable="true"
      size="md"
    >
      <VpConfirmModal modalId="removeOutput_ConfirmModal">
        <template v-slot:title>
          <span>{{ deselectOutput.label }}s</span>
        </template>

        <template v-slot:text1>
          <span>
            Are you sure you want to <strong>“Apply”</strong> this action?
          </span>
        </template>

        <template v-slot:text2>
          <span>
            By unchecking the “Sign in”, “Sign out” and “Check in” options, "{{
              deselectOutput.label
            }}" will be removed from this flow.
          </span>
        </template>

        <template v-slot:buttons>
          <VpButton text="Apply" @click="onConfirmationModalSubmit" />
          <VpButton
            text="Cancel"
            :disabled="false"
            :isDanger="true"
            @click="onCancel"
          />
        </template>
      </VpConfirmModal>
    </b-modal>
    <!-- Confirmation modal -->

    <div class="header">
      <h5>{{ $t('journeyBuilder.outputSettings') }}</h5>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="vp-pos-absolute vp-right-32 vp-top-32"
        @click="onHideModal"
      >
        <path
          d="M11 0C4.91333 0 0 4.88342 0 10.933C0 16.9826 4.91333 21.8661 11 21.8661C17.0867 21.8661 22 16.9826 22 10.933C22 4.88342 17.0867 0 11 0ZM16.5978 14.626C17.1111 15.1362 17.1111 15.9622 16.5978 16.4724C16.3289 16.7397 16.0111 16.8612 15.6689 16.8612C15.3267 16.8612 14.9844 16.7397 14.74 16.4724L11.0733 12.8281L7.38222 16.4724C7.11333 16.7397 6.79556 16.8612 6.45333 16.8612C6.11111 16.8612 5.76889 16.7397 5.52444 16.4724C5.01111 15.9622 5.01111 15.1362 5.52444 14.626L9.21556 10.9573L5.52444 7.31298C5.01111 6.80277 5.01111 5.97672 5.52444 5.46651C6.03778 4.95631 6.86889 4.95631 7.38222 5.46651L11.0733 9.13515L14.7644 5.46651C15.2778 4.95631 16.1089 4.95631 16.6222 5.46651C17.1356 5.97672 17.1356 6.80277 16.6222 7.31298L12.9311 10.9816L16.5978 14.626Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <div v-for="(output, index) in applyOutputSettings" :key="output.name">
      <!-- start:: print bade -->
      <div v-if="output.name === 'print_badge'">
        <div class="subheader-container">
          <h5>{{ $t('journeyBuilder.flow.printBadge')}}</h5>
        </div>
        <div class="checkbox-container">
          <b-form-checkbox
            @change="onLoginModeChange(output, 'checkIn')"
            v-model="$v.applyOutputSettings.$each.$iter[index].checkIn.$model"
            >{{ $t('common.checkIn' )}}</b-form-checkbox
          >
          <b-form-checkbox
            @change="onLoginModeChange(output, 'signIn')"
            v-model="$v.applyOutputSettings.$each.$iter[index].signIn.$model"
            >{{ $t('common.signIn') }}</b-form-checkbox
          >
          <b-form-checkbox
            @change="onLoginModeChange(output, 'signOut')"
            v-model="$v.applyOutputSettings.$each.$iter[index].signOut.$model"
            >{{ $t('common.signOut') }}</b-form-checkbox
          >
        </div>

        <div class="subheader-container">
          <h5>{{ $t('journeyBuilder.flow.showBadge') }}</h5>
        </div>
        <div
          v-for="setting in output.chlidren"
          :key="setting.id"
          class="setting-container"
          :class="{
            'display-setting': isDisplayed(setting, output),
            'display-none-animated': !isDisplayed(setting, output),
            'd-none': setting.id == '12' || setting.id == '13',
          }"
        >
          <!-- Exclude 'company name' (id = 12) & 'Date and time' (id = 13) settings  -->
          <span
            >{{ setting.label }}
            <svg
              v-if="setting.id == 113"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-inline-start: 16px"
              v-b-tooltip
              id="tooltip-svg"
            >
              <path
                d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                fill="#787878"
              />
            </svg>
            <b-tooltip
              placement="bottom"
              id="journey-logo-tooltip"
              target="tooltip-svg"
              triggers="click"
            >
              {{$t('journeyBuilder.notes.logoPrint')}}
            </b-tooltip>
          </span>
          <b-form-checkbox
            class="switch-gray custom-switch-input"
            switch
            size="lg"
            v-model="
              $v.applyOutputSettings.$each.$iter[index].chlidren[setting.name]
                .value.$model
            "
          ></b-form-checkbox>
        </div>
        <hr v-if="index < applyOutputSettings.length - 1" />
      </div>
      <!-- end:: print bade -->

      <!-- start:: save data -->
      <div v-if="output.name === 'save_data'">
        <div class="subheader-container">
          <h5 class="vp-mb-24">{{ $t('journeyBuilder.saveData') }}</h5>

          <div
            v-for="(setting, indx) in output.chlidren"
            :key="indx"
            class="setting-container"
          >
            <span>{{ setting.label }}</span>
            <b-form-checkbox
              class="switch-gray custom-switch-input"
              switch
              size="lg"
              v-model="
                $v.applyOutputSettings.$each.$iter[index].chlidren
                  .save_scan_image.value.$model
              "
            ></b-form-checkbox>
          </div>
          <hr v-if="index < applyOutputSettings.length - 1" />
        </div>
      </div>
      <!-- end:: save data -->

      <!-- start:: door relay -->
      <div v-if="output.name === 'door_relay'">
        <div class="subheader-container">
          <h5 class="vp-mb-24">{{ $t('journeyBuilder.flow.doorRelay') }}</h5>
          <div class="checkbox-container">
            <b-form-checkbox
              @change="onLoginModeChange(output, 'checkIn')"
              v-model="$v.applyOutputSettings.$each.$iter[index].checkIn.$model"
              >{{ $t('common.checkIn') }}</b-form-checkbox
            >
            <b-form-checkbox
              @change="onLoginModeChange(output, 'signIn')"
              v-model="$v.applyOutputSettings.$each.$iter[index].signIn.$model"
              >{{ $t('common.signIn') }}</b-form-checkbox
            >
            <b-form-checkbox
              @change="onLoginModeChange(output, 'signOut')"
              v-model="$v.applyOutputSettings.$each.$iter[index].signOut.$model"
              >{{ $t('common.signInOut') }}</b-form-checkbox
            >
          </div>
        </div>
        <hr v-if="index < applyOutputSettings.length - 1" />
      </div>
      <!-- start:: end relay -->

      <!-- start:: Weigand -->
      <div v-if="output.name === 'enable_weigand_output'">
        <div class="subheader-container">
          <h5 class="vp-mb-24">{{ $t('journeyBuilder.flow.weigandOutput') }}</h5>
          <h5 class="vp-mb-24">{{ $t('journeyBuilder.sendRFID')}}</h5>

          <div
            v-for="(setting, indx) in output.chlidren.weigand_output_settings
              .value"
            class="setting-container"
            :key="indx"
          >
            <span>{{ setting.name }}</span>
            <b-form-checkbox
              class="switch-gray custom-switch-input"
              switch
              size="lg"
              v-model="
                $v.applyOutputSettings.$each.$iter[index].chlidren
                  .weigand_output_settings.value.$each.$iter[indx].value.$model
              "
            ></b-form-checkbox>
          </div>
        </div>
        <hr v-if="index < applyOutputSettings.length - 1" />
      </div>
      <!-- end:: Weigand -->
    </div>

    <div class="d-flex justify-content-end">
      <button
        @click="submit"
        class="save-btn"
        :disabled="!$v.applyOutputSettings.$anyDirty"
      >
        {{ $t('common.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { journeyBuilderSettingsIDS } from "@/utils/Constants.js";
export default {
  props: {
    output: {
      default: () => [],
      type: Array,
    },
    isAttendanceModeSelected: {
      type: Boolean,
      default: false,
    },
    isTemerpatureCheckSelected: {
      type: Boolean,
      default: false,
    },
    isHostSelected: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    applyOutputSettings: {
      $each: {
        signIn: {},
        signOut: {},
        checkIn: {},
        chlidren: {
          print_badge_early_sign_out_reason: {
            value: {},
          },
          print_badge_host: {
            value: {},
          },
          print_badge_journey_company_logo: {
            value: {},
          },
          print_badge_late_sign_in_reason: {
            value: {},
          },
          show_company_name: {
            value: {},
          },
          show_date_time: {
            value: {},
          },
          show_name: {
            value: {},
          },
          show_photo: {
            value: {},
          },
          show_temperature: {
            value: {},
          },
          show_user_type: {
            value: {},
          },
          save_scan_image: {
            value: {},
          },
          weigand_output_settings: {
            value: {
              $each: {
                value: {},
              },
            },
          },
        },
      },
    },
  },

  data() {
    return {
      applyOutputSettings: [],
      tempOutputSettings: [],
      optionsWeigand: [
        { id: "rfid", name: this.$t('journeyBuilder.flow.outputSettingsRFID'), value: false },
        { id: "face_recognition", name: this.$t('jouneyBuilder.flow.outputSettingsFacialRecognition'), value: false },
      ],
      deselectOutput: "",
      latestLoginMode: "",
      printBadgeDisplayableSettingsIDS: [
        journeyBuilderSettingsIDS.show_temperature,
        journeyBuilderSettingsIDS.print_badge_host,
        journeyBuilderSettingsIDS.print_badge_late_sign_in_reason,
        journeyBuilderSettingsIDS.print_badge_early_sign_out_reason,
      ],
    };
  },
  methods: {
    isDisplayed(outputSetting, output) {
      if (!this.printBadgeDisplayableSettingsIDS.includes(outputSetting.id))
        return true;

      let display = false;
      // Check if temperature should be displayed
      if (
        outputSetting.id == journeyBuilderSettingsIDS.show_temperature &&
        this.isTemerpatureCheckSelected &&
        (output.checkIn || output.signIn)
      ) {
        display = true;
      }

      // Check if host badge should be printed
      if (
        outputSetting.id == journeyBuilderSettingsIDS.print_badge_host &&
        this.isHostSelected &&
        (output.checkIn || output.signIn)
      ) {
        display = true;
      }

      // Check if late sign-in reason should be printed
      if (
        outputSetting.id ==
          journeyBuilderSettingsIDS.print_badge_late_sign_in_reason &&
        this.isAttendanceModeSelected &&
        output.signIn
      ) {
        display = true;
      }

      // Check if early sign-out reason should be printed
      if (
        outputSetting.id ==
          journeyBuilderSettingsIDS.print_badge_early_sign_out_reason &&
        this.isAttendanceModeSelected &&
        output.signOut
      ) {
        display = true;
      }

      //Reset setting value to default (false) if it was unchecked and checked again.
      // if (!display) outputSetting.value = false;

      return display;
    },
    onLoginModeChange(output, targetObjectKey) {
      //If all login modes are deselected ,display confirmation modal + save latest deselected option (to be used in case of canelling action)
      if (!output.signIn && !output.signOut && !output.checkIn) {
        this.deselectOutput = output;
        this.latestLoginMode = targetObjectKey;
        this.$bvModal.show("removeOutput_ConfirmModal");
      }
    },
    onConfirmationModalSubmit() {
      //Remove output option from current applyOutputSettings object
      this.applyOutputSettings = this.applyOutputSettings.filter(
        (setting) => setting.name !== this.deselectOutput.name
      );

      //Remove output option from current output object on submit builder(parent) page
      this.$emit("removeOutput", this.deselectOutput);
      this.$bvModal.hide("removeOutput_ConfirmModal");

      //Hide output modal if all "outputs" are deselected
      if (!this.applyOutputSettings?.length) this.$bvModal.hide("output-modal");
    },
    onHideModal() {
      this.$emit("undoOutputChanges", this.tempOutputSettings);
      this.$bvModal.hide("output-modal");
    },
    onCancel() {
      //Set value of latest unselected option to true
      this.deselectOutput[this.latestLoginMode] = true;
      this.$bvModal.hide("removeOutput_ConfirmModal");
    },
    submit() {
      this.$emit("updateOutput", this.applyOutputSettings);
      this.$bvModal.hide("output-modal");
    },
  },
  mounted() {
    this.applyOutputSettings = cloneDeep(this.output);
    this.tempOutputSettings = cloneDeep(this.output);
  },
};
</script>

<style lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.25s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.display-setting {
  transition: all 0.25s ease-in-out;
  opacity: 1;
  scale: 1;
}
.display-none-animated {
  opacity: 0 !important;
  scale: 0 !important;
  height: 0 !important;
  margin: unset !important;
  padding: unset !important;
  transition: all 0.25s ease-in-out;
}

#journey-logo-tooltip {
  width: 137px;
  height: 126px;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  .tooltip-inner {
    box-shadow: unset;
  }
}
div#output-modal___BV_modal_body_ {
  padding: 40px 0 23px 0;
  overflow-x: hidden;
}
.output-setting {
  width: 416px;
  margin: auto;
  hr {
    margin-top: 32px;
  }
  .header h5 {
    font-size: 17px;
    font-weight: 700;
    line-height: 20.4px;
    color: #000000;
    text-align: center;
  }
  .subheader-container {
    margin: 32px 0;
  }
  .checkbox-container {
    width: 310px;
    display: flex;
    justify-content: space-between;
    .custom-control-label {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      letter-spacing: 0.25px;
      color: #787878;
    }
    .custom-control-input:checked ~ .custom-control-label {
      color: #103f5e;
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
      letter-spacing: 0.25px;
    }
  }
  h5 {
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
  }
  .save-btn {
    background: #103f5e;
    width: 416px;
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    letter-spacing: 0.25px;
    color: #ffffff;
    margin: 8px auto 17px;
  }
  .save-btn:disabled {
    background: #9fb2bf;
  }
  .multiselect__content-wrapper {
    position: relative !important;
  }
  .setting-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 416px;
    height: 55px;
    padding: 22px 20px 21px;
    background-color: #f2f2f2;
    margin-bottom: 16px;

    span {
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
      color: #787878;
    }
  }
  .switch-gray {
  .custom-control-input:checked ~ .custom-control-label::before {
    position: absolute;
    top: unset !important;
    width: 43px;
    height: 21px;
    background: #D1D1D1;
    border: 1.5px solid #D1D1D1!important;
    border-radius: 13.5px

  }

  .custom-control-input:checked ~ .custom-control-label::after{
    width: 21px!important;
    height: 21px!important;
    top: unset!important;
    background-color: #34C38F;
  }
   
  .custom-control-label::before{
    top: unset !important;
    width: 43px!important;
    height: 21px!important;
    background: #D1D1D1;
    border: 1.5px solid #D1D1D1!important;
    border-radius: 13.5px
  }
  .custom-control-label::after{
    width: 21px!important;
    height: 21px!important;
    top: unset!important;
    background: #939393;
    box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.18) !important;
  }

}
}
</style>
